<template>
  <div class="games">
    <div id="head-page" class="globulo parallaxe">
      <parallax>
        <div id="bg1" data-depth="0.3"><img class="" src="@/assets/images/head/sun.png" alt="" title="" /></div>
        <div id="bg2" data-depth="0.2"><img class="" src="@/assets/images/head/colines.png" alt="" title="" /></div>
        <div id="bg3" data-depth="0.1"><img class="" src="@/assets/images/head/montagnes.png" alt="" title="" /></div>
        <div id="bg4" data-depth="0.2"><img class="" src="@/assets/images/head/sapins.png" alt="" title="" /></div>
        <div id="bg5" data-depth="0.5"><img class="" src="@/assets/images/head/nuages.png" alt="" title="" /></div>
        <div id="front-1" data-depth="0.2"></div>
      </parallax>
    </div>

    <div class="grid-container content-page">
      <div class="grid-x grid-margin-x">
        <div class="small-12 medium-10 medium-offset-1  large-6 large-offset-3 cell center">

          <title-page attrpage="Avatar" baseline="">Personnalise ton avatar</title-page>

          <div class="form date">
            <avatar-editable :recipe="avatar"></avatar-editable>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import AvatarEditable from '@/components/AvatarEditable'
  import TitlePage from '@/components/TitlePage'
  import Bouton from '@/components/Bouton'

  export default {
    components: { AvatarEditable, TitlePage, Bouton },
    computed: {
      avatar () {
        return this.$store.state.me.avatar;
      }
    },
  }
</script>
